import React from "react";
import { Search, X, HelpCircle, LifeBuoy, ArrowDown } from "lucide-react";
import { Button } from "components/ui/button";

const HelpHero = ({ searchQuery, onSearchChange, onClearSearch, onScrollToSection }) => {
  return (
    <div className="relative overflow-hidden rounded-2xl bg-gradient-to-br from-indigo-900 via-slate-900 to-gray-900 text-white p-8 md:p-12 shadow-sm border border-slate-800">
      {/* Background ambient effect */}
      <div className="absolute top-0 right-0 -mr-16 -mt-16 w-80 h-80 rounded-full bg-blue-500/10 blur-3xl pointer-events-none" />
      <div className="absolute bottom-0 left-1/3 -mb-20 w-80 h-80 rounded-full bg-indigo-500/10 blur-3xl pointer-events-none" />

      <div className="relative z-10 max-w-3xl mx-auto text-center space-y-6">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-full bg-white/10 text-xs font-medium text-blue-200 backdrop-blur-sm border border-white/10">
          <LifeBuoy size={14} className="text-blue-300" />
          <span>Academic Online Help Center & Support</span>
        </div>

        <div className="space-y-2">
          <h1 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-white">
            How can we assist your research today?
          </h1>
          <p className="text-slate-300 text-sm md:text-base max-w-xl mx-auto leading-relaxed">
            Search our guides, explore feature FAQs, or reach out directly to our support engineers.
          </p>
        </div>

        {/* Search Input Box */}
        <div className="relative max-w-xl mx-auto">
          <div className="relative flex items-center">
            <Search className="absolute left-4 text-slate-400 pointer-events-none" size={20} />
            <input
              type="text"
              value={searchQuery}
              onChange={(e) => onSearchChange(e.target.value)}
              placeholder="Search by keyword, e.g. 'export', 'citations', 'assistant'..."
              className="w-full pl-12 pr-10 py-3.5 bg-white text-gray-900 rounded-xl text-sm md:text-base placeholder-gray-400 shadow-lg focus:outline-none focus:ring-2 focus:ring-blue-500 focus:bg-white transition-all"
            />
            {searchQuery && (
              <button
                onClick={onClearSearch}
                className="absolute right-3.5 p-1 rounded-full text-gray-400 hover:text-gray-700 hover:bg-gray-100 transition-colors"
                title="Clear search"
                type="button"
              >
                <X size={16} />
              </button>
            )}
          </div>
        </div>

        {/* Quick Jump Buttons */}
        <div className="flex flex-wrap items-center justify-center gap-2 pt-2 text-xs">
          <span className="text-slate-400 mr-1">Quick actions:</span>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onScrollToSection("quick-guides")}
            className="text-slate-200 hover:text-white hover:bg-white/10 h-7 text-xs rounded-full border border-white/10"
          >
            Feature Guides
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onScrollToSection("faq-section")}
            className="text-slate-200 hover:text-white hover:bg-white/10 h-7 text-xs rounded-full border border-white/10"
          >
            Frequently Asked
          </Button>
          <Button
            variant="ghost"
            size="sm"
            onClick={() => onScrollToSection("contact-support")}
            className="text-blue-300 hover:text-blue-200 hover:bg-white/10 h-7 text-xs rounded-full border border-blue-400/30 font-medium"
          >
            <ArrowDown size={12} className="mr-1" />
            Contact Support
          </Button>
        </div>
      </div>
    </div>
  );
};

export default HelpHero;
